let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k22Uk")).then(() => parcelRequire('9Qkn4'));